import { gql } from '@apollo/client'

export const DELETE_CHANNEL_API_KEY = gql`
  mutation DeleteChannelAPIKeys(
    $channelId: String!
    $apikeyID: String!
    $apikey: String!
    $description: String!
  ) {
    deleteChannelAPIKeys(
      channelId: $channelId
      apikeyID: $apikeyID
      apikey: $apikey
      description: $description
    ) {
      message
    }
  }
`
